import { useCallback } from 'react';
import { useLocation } from 'react-router-dom';

import { useAppSelector } from '@/redux/hooks';
import { getDeployment } from '@/redux/modules/config';
import { track } from '@/utils/amplitude/analytics/core';
import { TrackingEvents, TrackingPayload } from '@/utils/amplitude/analytics/core.types';
import { getFullUrl } from '@/utils/amplitude/analytics/utils/getFullUrl';
import { getAmplitudePageNameFromPath } from '@/utils/getPageNameFromPath';

import { AmpProduct } from './ampAdvertisements.types';

type AmpAvailableUniquePayload = {
    ampProduct: AmpProduct;
    catalogId: number | null;
    houseId: number | null;
};

type AmpAvailablePayload = TrackingPayload & AmpAvailableUniquePayload;

const trackAmpAvailable = (payload: AmpAvailablePayload) => {
    track(TrackingEvents.AuctionMarketingProgram.AmpAvailable, payload);
};

export const useTrackAmpAvailable = () => {
    const deployment = useAppSelector(getDeployment);
    const { pathname } = useLocation();

    return useCallback(
        ({ ampProduct, catalogId, houseId }: AmpAvailableUniquePayload) => {
            trackAmpAvailable({
                ampProduct,
                catalogId: catalogId || null,
                houseId: houseId || null,
                pageName: getAmplitudePageNameFromPath(pathname),
                url: getFullUrl(deployment, pathname),
            });
        },
        [pathname, deployment]
    );
};
